import React from 'react';
import { DashboardCard } from '../DashboardCard';

/**
 * Teams View Dashboard Card (Mobile)
 * Wrapper around shared DashboardCard with mobile variant
 */
const TeamsViewDashboardCard = ({ homepage, setPreviewPanel, setDialog, teamId }) => {
  return (
    <DashboardCard
      dashboard={homepage}
      setDialog={setDialog}
      setPreviewPanel={setPreviewPanel}
      teamId={teamId}
      variant="mobile"
      showHoverActions={false}
    />
  );
};

export default TeamsViewDashboardCard;
